module.exports = __webpack_public_path__ + "media/images/logo-04c6c4b7d931fda2a7a7a7b5f3afe5a1.png";